import * as React from 'react';
import styles from './index.less';
import wrapStore from '@src/utils/wrap-store';
import FooterStore from '@src/business-components/footer/store';
import AgeAppropriateTips from '@src/components/age-appropriate-tips';
import cx from 'classnames';
import Link from '@src/components/link';

const Footer = ({ store }) => {
  store.use();
  return (
    <div className={styles.footerRoot}>
      <div className={styles.leftTips}>
        <div className={styles.tipText}>{'为维护未成年人健康上网环境，\n本游戏暂不支持实名认证18岁以下的用户登录体验。'}</div>
        <div className={styles.ageTips}>
          <AgeAppropriateTips gameName={'尘白禁区'} />
        </div>
      </div>
      <div className={styles.content}>
        <div className={cx(styles.footerText, styles.type2)}>
          © 2021-2026 <span>{store.company}版权所有</span>
        </div>
        <div className={cx(styles.footerText, styles.type3)}>
          健康游戏忠告：抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。
        </div>
        <div className={styles.footerText}>
          <span>增值电信业务经营许可证琼B2-20210572 </span>
          <Link href={'https://beian.miit.gov.cn/#/Integrated/index'} target={'_blank'}>
            琼ICP备2021004338号-4
          </Link>
        </div>
        <div className={styles.footerText}>
          <Link
            href={
              'https://www.nppa.gov.cn/bsfw/jggs/cxjg/index.html?mc=%E5%B0%98%E7%99%BD%E7%A6%81%E5%8C%BA&cbdw=&yydw=&wh=undefined&description='
            }
            target={'_blank'}
          >
            审批文号: 国新出审[2022]1737号 ISBN 978-7-498-09913-6
          </Link>
          <Link href={'https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=46902302000767'} target={'_blank'}>
            琼公网安备 46902302000767号
          </Link>
        </div>
      </div>
      <div className={styles.footerLogo} />
    </div>
  );
};

export default wrapStore(Footer, FooterStore);
